import '@formatjs/intl-pluralrules/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'react-virtualized/styles.css';
import './index.scss';

import { bootstrapApplication } from './app';
import store from './store/store';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core';
import { theme } from './themes/mui';

const init = (App: any) => (
  <React.Fragment>
    <CssBaseline />
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          {App}
        </BrowserRouter>
        <CssBaseline />
      </ThemeProvider>
    </Provider>
  </React.Fragment>
);

bootstrapApplication({ locale: window.navigator.language }).then((app: React.ReactElement) => {
  ReactDOM.render(init(app), document.getElementById('root'))
});

document.addEventListener("load", () => serviceWorker.register());
